/**
 * The genre site this build serves, picked by NEXT_PUBLIC_SITE_GENRE
 * (inlined at build time, so server and client code see the same value).
 */

import type { GenreConfig, GenreId } from './genres/types';
import { METAL } from './genres/metal';
import { ROCK } from './genres/rock';
import { JAZZ } from './genres/jazz';
import { POP } from './genres/pop';

const GENRES: Record<GenreId, GenreConfig> = { metal: METAL, rock: ROCK, jazz: JAZZ, pop: POP };

function resolveGenre(): GenreConfig {
  const id = (process.env.NEXT_PUBLIC_SITE_GENRE ?? 'metal') as GenreId;
  const config = GENRES[id];
  if (!config) throw new Error(`Unknown NEXT_PUBLIC_SITE_GENRE "${id}"`);
  return config;
}

export const SITE = resolveGenre();
export const SITE_ORIGIN = `https://${SITE.domain}`;
